<template>
    <div v-cloak>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">

                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-7">
                                <div>
                                    <img class="app-icon" src="/img/apps/noise/app_icon.png" alt="Ping App Icon">
                                    <h1 class="display-3 text-white">
                                        Noise – Mix HD Ambient Sounds
                                        <span class="text-white">Create your optimal acoustic environment for relaxing, meditation and better sleep.</span>
                                    </h1>
                                </div>
                                <p class="lead text-white">
                                    <strong>Noise</strong> convinces through its large collection of crystal-clear high-quality sounds from a wide variety of areas. 
                                    Each sound is perfectly looped and can be combined to create an almost infite number of pleasant background sounds.
                                </p>
                                <div class="btn-wrapper">
                                    <a href="https://frhlch.at/f/noise?app=1" target="_blank">
                                        <img width="150" src="/img/app/download_appstore.png" alt="Download Noise on the App Store">
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-5">
                                <app-showcase 
                                    imageSrc="/img/apps/noise/video_placeholder.png" 
                                    videoSrc="https://www.dropbox.com/s/fxyadqzaghvwy1x/noise_showcase_scaled.mp4?dl=1" 
                                    posterSrc="/img/apps/noise/video_placeholder.png"
                                    class="floating"
                                    >
                                </app-showcase>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->

        <section class="section section-lg mb-100">
            <div class="container">
                <div class="row justify-content-center mb-lg">
                    <div class="col-lg-12">
                        <h2 class="display-3">Blend Out Distractions</h2>
                        <p class="lead text-muted">
                          Ambient noise improves concentration and helps to blend out distracting noises around you.                          
                        </p>
                        <p class="lead text-muted">
                          Whether you want to focus on your task at hand or just relax, there a plenty of situations in which distracting background noises prevent you from doing so.
                          This is, when <strong>Noise</strong> can help – Just select one of the many pleasant background noises and escape to a cozy fire place or lonely forest. 
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">

                            <div class="rounded-circle img-center img-fluid shadow shadow-lg--hover benefits-icon">
                              <img v-lazy="'img/app/icons/ic_sounds.svg'" class="img-center img-fluid">
                            </div>

                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Crystal-Clear Sounds</span>
                                    <small class="h6 text-muted">Whether you need a calm beach waves or a busy coffee shop, Noise has you covered with numerous high qualitys sounds.</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                           <div class="rounded-circle img-center img-fluid shadow shadow-lg--hover benefits-icon">
                              <img v-lazy="'img/app/icons/ic_combine.svg'" class="img-center img-fluid">
                            </div>
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Combine & Mix Sounds</span>
                                    <small class="h6 text-muted">Combine any number of sounds to create the perfect acoustic environment just for you.</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                           <div class="rounded-circle img-center img-fluid shadow shadow-lg--hover benefits-icon">
                              <img v-lazy="'img/app/icons/ic_mixtape.svg'" class="img-center img-fluid">
                            </div>
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Create Mixtapes</span>
                                    <small class="h6 text-muted">Create individual mixtapes for different situations such as working, meditation or relaxing and sleeping.</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                           <div class="rounded-circle img-center img-fluid shadow shadow-lg--hover benefits-icon">
                              <img v-lazy="'img/app/icons/ic_no_ads.svg'" class="img-center img-fluid">
                            </div>
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">No Advertisment</span>
                                    <small class="h6 text-muted">Taking about distractions... We don’t want tons of annoying ads to stop you from enjoying Noise. Zero Ads. Pinky Promise.</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-noise shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-7">
                        <div class="d-flex px-3">
                            <div class="pl-4" style="margin-left: -2.5rem;">
                                <h4 class="display-3 text-white">Noise Premium</h4>
                                <p class="text-white">Noise Premium has even more to offer.</p>
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                  <div class="rounded-circle img-center img-fluid shadow shadow-lg--hover purchases-icon">
                                    <img v-lazy="'img/app/icons/ic_plus.svg'" class="img-center img-fluid">
                                  </div>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-noise">Additional Sounds</h5>
                                    <p>
                                      We offer a wide range of high-quality sounds in addition to those included in the free version of the app. 
                                    </p>
                                    <p>
                                      If you can't find the sound you are looking for, let us know in the comment section of the App Store and we will try to get it for you.
                                    </p>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                  <div class="rounded-circle img-center img-fluid shadow shadow-lg--hover purchases-icon">
                                    <img v-lazy="'img/app/icons/ic_headphones.svg'" class="img-center img-fluid">
                                  </div>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-noise">Play in Background</h5>
                                    <p>
                                      You enjoy listening with your phone locked? <strong>Play in Background</strong>  and Noise will continue playing after you locked your phone.
                                    </p>
                                    <p><strong>Bonus:</strong> If you get <strong>Play in Background</strong>  you will also be able to play Noise via Airplay.</p>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                  <div class="rounded-circle img-center img-fluid shadow shadow-lg--hover purchases-icon">
                                    <img v-lazy="'img/app/icons/ic_vip.svg'" class="img-center img-fluid">
                                  </div>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-noise">Noise Premium</h5>
                                    <p>
                                      You like Noise and want to have all premium sounds and features? Then get <strong>Noise Premium</strong> and enjoy all sounds/ features (including future ones).
                                    </p>
                                </div>
                            </div>
                        </card>
                    </div>
                    <div class="col-lg-5 col-md-12">
                        <div class="position-relative pl-md-5">
                            <img src="img/apps/noise/noise_preview_additional_sounds.png" class="img-center img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-lg pt-0 mt-100">
            <div class="container">
                <card no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="">Try Noise today!</h3>
                                <p class=" mt-3">    
                                    <strong>Noise</strong> was built exclusively for iOS – the minimal and delightful design combines perfectly with all the apps you know and love on your iPhone. 
                                </p>
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <div class="btn-wrapper">
                                    <a href="https://frhlch.at/f/noise?app=1" target="_blank">
                                        <img width="150" src="/img/app/download_appstore.png" alt="Download Noise on the App Store">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>

        </div>

    <div class="bottom-spacer"></div>

    </div>
</template>

<script>
export default {
  name: "Noise",
  components: {}
};
</script>

<style scoped lang="css">
    .no-pointer-events {
        pointer-events: none;
    }

    h1 {
        display: inline-grid;
    }

    h1 span {
        font-size: 1.5rem;
        color: rgba(0,0,0,0.7);
    }

    .app-icon {
        width: 70px;
        height: 70px;
        object-fit: contain;
        display: inline-grid;
        margin-right: 15px;
        margin-top: 10px;
    }

    .app-showcase {
        width: 350px;
        height: 700px;
        margin: auto;
        margin-top: 60px;
    }

    @media (min-width: 992px) {
        .app-showcase {
            position: absolute;
            top: -65px;
            right: 0;
        }
    }

    .section-shaped .shape-style-1.shape-default {
      /* background: linear-gradient(150deg, #ffffff 15%, #e0e0e0 70%, #afafaf 94%); */
      background: rgb(66, 204, 201);
    }

    .benefits-icon {
      padding: 54px;
    }

    .benefits-icon img {
      width: 180px;
    }

    .purchases-icon {
      padding: 10px;
    }

    .purchases-icon img {
      width: 180px;
    }

    @media (max-width: 995px) {
      .benefits-icon {
        padding: 40px;
        height: 120px;
        width: 120px;
        
      }

      .benefits-icon img {
        width: 80px;
      }

        .purchases-icon img {
        width: 120px;
        }
    }

    .text-noise {
      color: rgb(66, 204, 201) !important;
    }

    small.h6 {
      font-size: 0.9rem;
    }

    .bg-gradient-noise {
      background: rgb(66, 204, 201);
    }

    .bottom-spacer {
        margin-bottom: 100px;
    }

    .mt-100 {
        margin-top: 100px;
    }

    .mb-100 {
      margin-bottom: 100px;
    }

</style>
